import { Directive, OnInit, OnDestroy, AfterViewInit, Input, ElementRef, HostListener } from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { TooltipManagerService } from "../services/tooltip-manager.service";

@Directive({
  selector: '[ngbTooltip]',
  standalone: true
})
export class GlobalTooltipInterceptorDirective implements OnInit, OnDestroy, AfterViewInit {
  openTimeout: any = null;
  private allowOpen = false;
  private originalOpen!: (context?: any) => void;
  private originalClose!: () => void;
  // Intercept the triggers input
  @Input() 
  set triggers(value: string) {
    // Always set to manual, ignore the input value
    this.ngbTooltip.triggers = 'manual';
  }

  constructor(
    private ngbTooltip: NgbTooltip,
    private tooltipManager: TooltipManagerService,
    private el: ElementRef
  ) {
    this.tooltipManager.register(this.ngbTooltip);
    this.originalOpen = this.ngbTooltip.open.bind(this.ngbTooltip);
    this.originalClose = this.ngbTooltip.close.bind(this.ngbTooltip);
    // Block default hover opens even if template sets triggers
    this.ngbTooltip.triggers = 'manual';
    this.ngbTooltip.disableTooltip = true;
    this.ngbTooltip.open = (context?: any) => {
      if (!this.allowOpen || this.ngbTooltip.disableTooltip) {
        return;
      }
      this.originalOpen(context);
    };
    this.ngbTooltip.close = () => {
      this.originalClose();
    };
    
    // Remove title attribute
    this.el.nativeElement.removeAttribute('title');
  }

  ngOnDestroy(): void {
    // Clean up: unregister tooltip and clear any pending timeouts
    this.tooltipManager.unregister(this.ngbTooltip);
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
    // Restore original methods
    this.ngbTooltip.open = this.originalOpen;
    this.ngbTooltip.close = this.originalClose;
  }

  ngOnInit() {
    // Force manual triggers
    this.ngbTooltip.triggers = 'manual';
    this.ngbTooltip.disableTooltip = true;
  }

  ngAfterViewInit() {
    // Ensure triggers stay manual after all inputs are processed
    setTimeout(() => {
      this.ngbTooltip.triggers = 'manual';
    },500);
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.tooltipManager.closeAllExcept(this.ngbTooltip);
    
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
    }
    
    this.openTimeout = setTimeout(() => {
      if (!this.ngbTooltip.isOpen()) {
        // Uncomment the next four lines to allow opening from this directive
        this.allowOpen = true;
        this.ngbTooltip.disableTooltip = false;
        this.ngbTooltip.open();
        this.allowOpen = false;
      }
    }, 500);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
    
    if (this.ngbTooltip.isOpen()) {
      this.ngbTooltip.close();
    }
    this.ngbTooltip.disableTooltip = true;
  }

  // ...rest of your code...
}